export const siteDataTypes = {
    'SET_SITE_DATA': "SET_SITE_DATA",
    "SET_USER_GROUPS": "SET_USER_GROUPS"
}